import { render, staticRenderFns } from "./Purchase-Expense.vue?vue&type=template&id=76f0c42f"
import script from "./Purchase-Expense.vue?vue&type=script&lang=js"
export * from "./Purchase-Expense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports